import React from 'react';
import DOMPurify from 'dompurify';

export const TipBlockControl = ({field} : ControlParameters) : JSX.Element => {

  const cleanHtmlString = DOMPurify.sanitize(field.settings.Tip, { ADD_ATTR: ['target'] });

  return (
    <div className={ `tipblock tipblock--${field.settings.Layout}` }>
      <div className={'tipblock-icon'}>
        <i className={`icon-${field.settings.Icon}`}></i>
      </div>
      <p className={'tipblock-text'} dangerouslySetInnerHTML={{ __html: cleanHtmlString }}></p>
    </div>
  );
};